import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "components/app/dialog/dialog";
import NumberInput from "components/app/function/NumberInput";
import { Button } from "components/ui/button";
import { ScrollArea, ScrollBar } from "components/ui/scroll-area";
import { Textarea } from "components/ui/textarea";
import { Loader, X } from "lucide-react";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { AppLog } from "services";
import { useAppSelector } from "store/store";
import { RequestApi, RouteApi, StatusMsg } from "utils";

interface DialogProps {
  isDailogAddModifier: boolean;
  id: any;
  setisDailogAddModifier: (value: boolean) => void;
  editItemShopProduct: any;
  setEditItemShopProduct: any;
  // updateImage: (newImage: File) => void; // Add this to update the image in parent component
}
export default function DailogAdddModifier({
  isDailogAddModifier,
  setisDailogAddModifier,
  editItemShopProduct,
  setEditItemShopProduct,
  id,
}: // updateImage, // Add this prop to pass the updated image back to the parent component
DialogProps) {
  const { token } = useAppSelector((state) => state.auth);
  const [loadingSubmitAddModifier, setLoadingSubmitAddModifier] = useState<boolean>(false);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [message, setMessage] = useState<string>("");
  const shopId = searchParams.get("id");

  const [formData, setFormData] = useState({
    local_description: "",
    unit_price: "",
  });
  const clearData = () => {
    setFormData({
      local_description: "",
      unit_price: "",
    });
  };

  const onSubmitAddModifier = async () => {
    setLoadingSubmitAddModifier(true);
    try {
      let url: string = "";
      url = RouteApi.submitInsertShopProductModifier;
      url += `token=${token}`;
      const pyaload = {
        product_id: editItemShopProduct.id,
        product_group_id: id,
        shop_id: shopId,
        local_description: formData.local_description,
        unit_price: formData.unit_price,
      };
      const response = await RequestApi(url, { data: pyaload });
      if (response.status === "success") {
        setLoadingSubmitAddModifier(false);
        setMessage("");
        setisDailogAddModifier(false);
        if (response.user_shop_product_modifier) {
          setEditItemShopProduct((prevItemGroups: any) => {
            // Ensure modifiers is an array (convert from object or undefined)
            const modifiersArray = Array.isArray(prevItemGroups.modifiers) ? prevItemGroups.modifiers : [];
            return {
              ...prevItemGroups,
              modifiers: [...modifiersArray, response.user_shop_product_modifier],
            };
          });
        }
        clearData();
      }
    } catch (error) {
      AppLog.show({
        message: `[onSubmitAddModifier]`,
        status: StatusMsg.error,
        error,
      });

      setLoadingSubmitAddModifier(false);
    } finally {
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, key: string) => {
    setFormData((prev) => ({ ...prev, [key]: e.target.value }));
  };

  useEffect(() => {
    if (formData.local_description !== "") {
      setMessage("");
    }
  }, []);
  return (
    <Dialog open={isDailogAddModifier}>
      <DialogContent isShowBtnXClose={false} className="custom-dialog-class flex flex-col justify-between">
        <DialogHeader>
          <DialogTitle> Add Item Modifier </DialogTitle>
          <DialogDescription>Input item modifier description and price, click "Save" when you finished</DialogDescription>
          <div
            className="absolute flex items-center justify-center right-4 top-1 z-40 cursor-pointer rounded-full bg-gray-200 dark:bg-accent w-[28px] h-[28px]"
            onClick={() => {
              setisDailogAddModifier(false);
              setMessage("");
            }}
          >
            <X />
          </div>
        </DialogHeader>
        <ScrollArea className="mt-2 w-full gap-3">
          <div className="flex flex-col py-[10px]">
            <div className="sticky top-0 left-0 bg-white dark:bg-[#020817] px-1">
              <div>
                <label htmlFor="local_description" className="block mb-1 text-sm font-medium">
                  Description <span className="text-red-600">*</span>
                </label>
                <Textarea value={formData.local_description} onChange={(e) => handleChange(e, "local_description")} rows={3} />
              </div>
              {formData.local_description === "" ? <label className="text-red-600 text-sm">{message}</label> : ""}
              <div className="mt-2">
                <label htmlFor="unit_price" className="block mb-1 text-sm font-medium">
                  Unit Price
                </label>
                <NumberInput value={formData.unit_price} onChange={(e) => handleChange(e, "unit_price")} />
                {/* border outline-none focus:border-blue-500 border-gray-300 text-md bg-transpaent dark:text-white rounded-lg block rounded-full w-full */}
              </div>
            </div>
          </div>
          <ScrollBar orientation="vertical" />
        </ScrollArea>
        <DialogFooter>
          <Button
            onClick={() => {
              if (formData.local_description === "") {
                setMessage("Descrption is required *");
                return;
              } else {
                onSubmitAddModifier();
              }
            }}
            className="w-full text-white mt-3 bg-blue-600 hover:bg-blue-500"
          >
            {loadingSubmitAddModifier ? <Loader className="animate-spin" /> : "Save"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
